/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import HeroVideo from '../components/hero-video'
import ScrollingBanner from '../components/scrolling-banner'
import VerticalList from '../components/vertical-list'
import OriginalsPortfolio from '../components/originals-portfolio'

const OriginalsPage = ({ data }) => (
  <div className='wrapper--page-dark page--originals'>
    <Helmet title='Originals - ATTN:' />
    <Header theme='dark' />
    <div className='hero--fullbleed'>
      <HeroVideo
        desktopPosterSrc={data.hero.image_desktop.url}
        mobilePosterSrc={data.hero.image_mobile.url}
        desktopVideoSrc={data.hero.loop_desktop.file.url}
        mobileVideoSrc={data.hero.loop_mobile.file.url}
      />
    </div>
    <div className='originals-intro'>
      <div className='originals-intro__body'>
        We enrich feeds and screens with content that makes an <span>impact</span>.
      </div>
    </div>
    <ScrollingBanner background='blue' text='Our work' length={10} />
    <VerticalList verticals={data.originals.edges} />
    <div className='originals-reach'>
      <div className='originals-reach__body'>
        <div className='originals-reach__copy'>
          We are the trusted partner for public figures, brands and platforms to
          engage Millennials and Gen Z around social good.
        </div>
        <div className='originals-reach__stats'>
          <div className='originals-reach__stat'>
            <span className='originals-reach__stat-number'>18B</span>
            <span className='originals-reach__stat-label'>Video views</span>
          </div>
          <div className='originals-reach__stat'>
            <span className='originals-reach__stat-number'>9B</span>
            <span className='originals-reach__stat-label'>Minutes watched</span>
          </div>
          <div className='originals-reach__stat'>
            <span className='originals-reach__stat-number'>19M</span>
            <span className='originals-reach__stat-label'>Followers</span>
          </div>
          <div className='originals-reach__stat'>
            <span className='originals-reach__stat-number'>15+</span>
            <span className='originals-reach__stat-label'>Awards for purpose</span>
          </div>
        </div>
      </div>
    </div>
    <ScrollingBanner background='black' text='Brand studio' iconColor='red' length={10} />
    <div className='originals-brand-partnerships'>
      <VerticalList verticals={data.brandPartnerships.edges} />
    </div>
    <OriginalsPortfolio portfolio={data.originalsImages.edges} />
    <Footer />
  </div>
)

OriginalsPage.propTypes = {
  data: PropTypes.object
}

export default OriginalsPage

export const query = graphql`
  query OriginalsPage {
    hero: drupalMedia(pid: {eq: "122"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    originals: allDrupalVertical(filter: {weight: {lt: 0}}, sort: {fields: [weight], order: DESC}) {
      edges {
        node {
          id
          label
          title
          description
          platform
          cta {
            title
            url {
              path
            }
          }
          image_desktop {
            url
          }
          image_mobile {
            url
          }
          video_desktop {
            file {
              url
            }
          }
          video_mobile {
            file {
              url
            }
          }
        }
      }
    }
    originalsImages: allDrupalMedia(filter: {label: {regex: "/^ORIGINALS-\\w+/i"}}, sort: {fields: [weight], order: ASC}) {
      edges {
        node {
          id
          image_mobile {
            url
          }
          image_desktop {
            url
          }
        }
      }
    }
    brandPartnerships: allDrupalProject(filter: {weight: {lt: 0}}, sort: {fields: [weight], order: DESC}) {
      edges {
        node {
          id
          label
          platform: eyebrow
          title
          description
          cta: link {
            title
            url {
              path
            }
          }
          image_mobile {
            url
          }
          image_desktop {
            url
          }
          video_mobile: loop_mobile {
            file {
              url
            }
          }
          video_desktop: loop_desktop {
            file {
              url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/originals.js